import type { AxiosError } from 'axios';
import type { ErrorResponse, OrganizationExceptionData } from '@inmotion/models';

interface InvalidOrganizationExceptionResponse extends ErrorResponse<number> {
  exceptionData?: OrganizationExceptionData;
}

export default function getOrganizationExceptionErrorData(error: Error, errorCode = 23) {
  const errorResponseData = (error as AxiosError)?.response
    ?.data as InvalidOrganizationExceptionResponse;
  if (
    errorResponseData?.errorCode === errorCode &&
    errorResponseData?.exceptionData?.organizationId
  ) {
    return errorResponseData.exceptionData;
  }
  return null;
}
